var hotelData = [
    {   category: 'coxs bazar',
        title: 'Light bright airy stylish apt & safe peaceful stay',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.9(20) $34/night",
        image: "https://i.imgur.com/4rWebP7.png"
    },
    {   category: 'coxs bazar',
        title: 'Apaertment in Lost Panorama',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.8(10)  $52/night",
        image: "https://i.imgur.com/79ssFzD.png"
    },
    {   category: 'coxs bazar',
        title: 'AR Lounge & Pool(r&r+b&b)',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.9(25)  $44/night",
        image: "https://i.imgur.com/h3BoshJ.png"
    },
    {   category: 'sreemangal',
        title: 'Nice view wide balcony apartment',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.9(25)  $34/night",
        image: "https://i.imgur.com/79ssFzD.png"
    },
    {   category: 'sreemangal',
        title: 'Beautiful spacious villa for family functions',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.9(20)  $34/night",
        image: "https://i.imgur.com/h3BoshJ.png"
    },
    {   category: 'sreemangal',
        title: 'Vacation with all the important facilities',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.9(20)  $34/night",
        image: "https://i.imgur.com/4rWebP7.png"
    },
    {   category: 'sundarbans',
        title: 'Experience the jungle with a safe stay',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.9(20)  $34/night",
        image: "https://i.imgur.com/h3BoshJ.png"
    },
    {   category: 'sundarbans',
        title: 'Complete silence with peaceful nature',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.9(20)  $34/night",
        image: "https://i.imgur.com/4rWebP7.png"
    },
    {   category: 'sundarbans',
        title: 'Fantastic stay in wild life with wild life',
        guestsAndBed: "4 guests  2 bedroom  2 beds  2 baths",
        facilities: "Wifi Air conditioning Kitchen",
        cancellation: "Cancellation flexibility available",
        ratingAndPrice: "4.9(20)  $34/night",
        image: "https://i.imgur.com/79ssFzD.png"
    },
    
    
    
];
export default hotelData;